import React, { useState } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { toast } from 'react-toastify'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom'
import { AddBox, Bookmarks, Cancel, Menu } from '@mui/icons-material'
import { FetchApi } from '../../../api/fetch'
import { useAuth } from '../../../contexts/AuthContext'
import { ENDPOINT, GO_DE_GQL_BACKEND_URL, Routes } from '../../../constants'
import Button from '../../../components/Button'
import Modal from '../../../components/Modal'
import BtnGradient from '../../../components/GradientButton'
import { QUERY_COURSE_SUB_CATEGORIES } from './query'
import { SPECIAL_CHARACTERS } from './constant'

type CategoryProps = {
   id: string;
   categoryID: string;
   name: string;
   position: number;
   createdAt?: string;
}
function SubCategory() {
   const { getUserJWT,  setIsLoadingOverlayDisplay } = useAuth()
   const { push } = useHistory()
   const { state }: any = useLocation()
   const { category }: any = useParams()

   const [subcategories, setSubCategories] = useState<CategoryProps[]>([])
   const [selected, setSelected] = useState<CategoryProps | null>(null)
   const [deleteInitiated, setDeleteInitiated] = useState<boolean>()

   React.useEffect(() => {
      getSubCategories()
   }, [])

   const getSubCategories = async () => {
      if (!state) {
         push("/dashboard/course-categories")
      }
      setIsLoadingOverlayDisplay(true)
      try {
         const cat = await FetchApi({
            endpoint: GO_DE_GQL_BACKEND_URL,
            method: "POST",
            body:  ({
               query: QUERY_COURSE_SUB_CATEGORIES,
               variables: { categoryID: state }
            })
         })
         const sorted = cat?.data?.courseSubCategory?.nodes?.sort((a: CategoryProps, b: CategoryProps) => a?.position - b?.position)
         setSubCategories(sorted)
      } catch (error) {
         // :TODO
         // add error toast
         console.log(error);

      }
      setIsLoadingOverlayDisplay(false)

   }

   const onDragEnd = (result: any) => {
      // dropped outside the list
      if (!result.destination) {
         return;
      }
      const newItems = [...subcategories];
      const [reordered] = newItems.splice(result.source.index, 1);
      newItems.splice(result.destination.index, 0, reordered);
      setSubCategories(newItems)
      saveEntry(reordered, result.destination.index + 1)

   }

   const initiateCreate = () => {
      setSubCategories([
         { id: "-1", name: "", position: 1, categoryID: state },
         ...subcategories
      ])
   }

   const handleValueChange = (e: any, id: string) => {
      let tempArr = subcategories.map((item) => {
         if (item.id === id) {
            item.name = e.target.value
         }
         return item
      })

      setSubCategories(tempArr)
   }

   const saveEntry = async (item: CategoryProps, position?: number) => {
      if (!position) {
         setIsLoadingOverlayDisplay(true)
      }
      const userJWT = await getUserJWT()
      try {
         let response
         if (item.id === "-1") {
            response = await FetchApi({
               endpoint: `${ENDPOINT.BASE_ENDPOINT_ACADEMY}/${item.categoryID}/create-sub-category`,
               method: "POST",
               JWT: userJWT,
               body:  ({ name: item.name, position: 1 })
            })
         } else {
            response = await FetchApi({
               endpoint: `${ENDPOINT.BASE_ENDPOINT_ACADEMY}/${item.id}/edit-sub-category`,
               method: "PATCH",
               JWT: userJWT,
               body:  ({ name: item.name, position })
            })
         }

         if (response) {
            toast.success(response.message)
            setSelected(null)
         }
         getSubCategories()

      } catch (error) {
         console.log('something went wrong', error);
      }
      setIsLoadingOverlayDisplay(false)

   }

   const cancelEntry = (item: CategoryProps) => {
      if (item.id === "-1") {
         let tempArr: any = subcategories?.splice(1)
         setSubCategories(tempArr)
      } else {
         setSelected(null)
      }
   }


   const handleClose = () => {
      setDeleteInitiated(false)
   }
   const onDelete = (item: CategoryProps) => {
      setDeleteInitiated(true)
      setSelected(item)
   }

   const deleteSubCategory = async () => {
      setIsLoadingOverlayDisplay(true)
      const userJWT = await getUserJWT()
      try {
         let response: any = await FetchApi({
            endpoint: `${ENDPOINT.BASE_ENDPOINT_ACADEMY}/${selected?.id}/delete-sub-category`,
            method: "DELETE",
            JWT: userJWT
         })

         if (response) {
            getSubCategories();
            toast.success(response.message)
         }

         setIsLoadingOverlayDisplay(false)
         setDeleteInitiated(false)
         setSelected(null)
      } catch (error: any) {
         console.log('something went wrong');
         setIsLoadingOverlayDisplay(false)
         toast.error(error.message)

      }
   }
   return (
      <div className='w-11/12 m-auto my-6'>
         <h1 className="font-normal mb-8 text-3xl text-left">
            Kyzzen Academy Dashboard
         </h1>
         <div className="mt-0 mb-12 flex flex-row justify-between items-center sm:flex-row">
            <div className='flex items-center justify-center gap-2'>
               <h1 className="font-extralight text-2xl text-left capitalize cursor-pointer" onClick={() => push(`/dashboard/course-categories/`)}>
                  {category.replaceAll('-', ' ')}
               </h1>
               <svg className="w-5 h-5  mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" />
               </svg>
               <h1 className="font-extralight text-2xl text-left">
                  Sub-Categories
               </h1>
            </div>

            <div className="w-full sm:w-auto flex items-center space-x-4">
               <BtnGradient>
                  <Button
                     onClick={initiateCreate}
                     type="button"
                     className=" w-auto text-white text-sm font-medium flex items-center gap-2 btn bg-transparent"
                  >
                     Create New
                     <AddBox />
                  </Button>
               </BtnGradient>
            </div>
         </div>
         <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId='featured'>
               {(provided) => (
                  <div
                     className=''
                     {...provided.droppableProps}
                     ref={provided.innerRef}
                  // style={getListStyle(snapshot.isDraggingOver)}
                  >
                     {
                        subcategories?.map((item: any, index: number) => (
                           <Draggable key={index} draggableId={item.id} index={index}>
                              {(provided) => (
                                 <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                 >
                                    <div className="bg-gray-80 flex items-center justify-between p-4 my-4 rounded-xl">
                                       <div className='flex items-center w-full'>
                                          <div>
                                             <Menu className="h-8 text-gray-50 mr-3" />
                                          </div>
                                          <div className='w-10/12'>
                                             {
                                                (item.id === "-1" || item.id === selected?.id) ?
                                                   <input className="font-normal bg-transparent outline-none w-full" placeholder='Enter Sub-Category Name' value={item.name} onChange={(e) => handleValueChange(e, item?.id)} readOnly={item.id !== "-1" && !selected?.id} /> :
                                                   <Link to={{
                                                      pathname: `${Routes.COURSES_CATEGORY}/${category}/sub-category/${item.name.toLowerCase().replaceAll(SPECIAL_CHARACTERS, '-')}/courses/`,
                                                      state: item
                                                   }}>
                                                      <h3 className="font-normal w-full">{item.name}</h3>
                                                   </Link>
                                             }

                                          </div>
                                       </div>
                                       {
                                          (item.id !== "-1" && selected?.id !== item.id) &&
                                          <div className="flex">
                                             <button onClick={() => setSelected(item)} className="border border-gray-50 text-gray-50 py-1.5 px-3 rounded-xl flex items-center gap-2 mr-3 text-xs">
                                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                   <path d="M14 15.166H2C1.72667 15.166 1.5 14.9393 1.5 14.666C1.5 14.3927 1.72667 14.166 2 14.166H14C14.2733 14.166 14.5 14.3927 14.5 14.666C14.5 14.9393 14.2733 15.166 14 15.166Z" fill="#667085" />
                                                   <path d="M12.6804 2.82043C11.387 1.5271 10.1204 1.49376 8.79371 2.82043L7.98704 3.6271C7.92037 3.69376 7.89371 3.80043 7.92038 3.89376C8.42704 5.66043 9.84038 7.07376 11.607 7.58043C11.6337 7.5871 11.6604 7.59376 11.687 7.59376C11.7604 7.59376 11.827 7.5671 11.8804 7.51376L12.6804 6.7071C13.3404 6.05376 13.6604 5.42043 13.6604 4.78043C13.667 4.12043 13.347 3.48043 12.6804 2.82043Z" fill="#667085" />
                                                   <path d="M10.4056 8.18654C10.2122 8.0932 10.0256 7.99987 9.84558 7.8932C9.69891 7.80654 9.55891 7.7132 9.41891 7.6132C9.30558 7.53987 9.17224 7.4332 9.04558 7.32654C9.03224 7.31987 8.98558 7.27987 8.93224 7.22654C8.71224 7.03987 8.46558 6.79987 8.24558 6.5332C8.22558 6.51987 8.19224 6.4732 8.14558 6.4132C8.07891 6.3332 7.96558 6.19987 7.86558 6.04654C7.78558 5.94654 7.69224 5.79987 7.60558 5.6532C7.49891 5.4732 7.40558 5.2932 7.31224 5.10654C7.18987 4.84431 6.8457 4.76641 6.64108 4.97103L2.89224 8.71987C2.80558 8.80654 2.72558 8.9732 2.70558 9.08654L2.34558 11.6399C2.27891 12.0932 2.40558 12.5199 2.68558 12.8065C2.92558 13.0399 3.25891 13.1665 3.61891 13.1665C3.69891 13.1665 3.77891 13.1599 3.85891 13.1465L6.41891 12.7865C6.53891 12.7665 6.70558 12.6865 6.78558 12.5999L10.5406 8.84484C10.7411 8.64432 10.6658 8.29929 10.4056 8.18654Z" fill="#667085" />
                                                </svg>
                                                Edit
                                             </button>
                                             <button onClick={() => onDelete(item)} className="border border-gray-50 text-gray-50 py-1.5 px-3 rounded-xl flex items-center gap-2 mr-3 text-xs">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M21.07 5.23c-1.61-.16-3.22-.28-4.84-.37v-.01l-.22-1.3c-.15-.92-.37-2.3-2.71-2.3h-2.62c-2.33 0-2.55 1.32-2.71 2.29l-.21 1.28c-.93.06-1.86.12-2.79.21l-2.04.2c-.42.04-.72.41-.68.82.04.41.4.71.82.67l2.04-.2c5.24-.52 10.52-.32 15.82.21h.08c.38 0 .71-.29.75-.68a.766.766 0 0 0-.69-.82ZM19.23 8.14c-.24-.25-.57-.39-.91-.39H5.68c-.34 0-.68.14-.91.39-.23.25-.36.59-.34.94l.62 10.26c.11 1.52.25 3.42 3.74 3.42h6.42c3.49 0 3.63-1.89 3.74-3.42l.62-10.25c.02-.36-.11-.7-.34-.95Zm-5.57 9.61h-3.33c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.33c.41 0 .75.34.75.75s-.34.75-.75.75Zm.84-4h-5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75Z" fill="#667085"></path></svg>

                                                Delete
                                             </button>
                                          </div>
                                       }
                                       {
                                          (item.id === "-1" || item.id === selected?.id) &&
                                          <div className="flex">
                                             <button onClick={() => saveEntry(item)} className="border border-gray-50 text-gray-50 py-1.5 px-3 rounded-xl flex items-center gap-2 mr-3 text-xs">
                                                <Bookmarks className="text-gray-50" fontSize='small' />
                                                Save
                                             </button>
                                             <button onClick={() => cancelEntry(item)} className="border border-gray-50 text-gray-50 py-1.5 px-3 rounded-xl flex items-center gap-2 mr-3 text-xs">
                                                <Cancel className="text-gray-50" fontSize='small' />
                                                Cancel
                                             </button>
                                          </div>
                                       }
                                    </div>
                                 </div>
                              )}
                           </Draggable>
                        ))
                     }
                     {provided.placeholder}
                  </div>
               )}
            </Droppable>
         </DragDropContext>
         {subcategories.length < 1 && <p className='text-xl text-center'>No Sub-Category Found...</p>}

         <Modal show={deleteInitiated} hide={handleClose} sub='Are you sure you want to delete sub-category'>
            <div className='flex justify-center gap-3 mt-8'>
               <div className=" text-center">
                  <button onClick={handleClose} className="block bg-gradient rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 text-md text-semibold">
                     <span
                        className="w-36 bg-gray-90 block m-0.5 rounded-lg py-3"
                     >
                        No
                     </span>
                  </button>
               </div>
               <Button
                  type="button"
                  className="mb-0 sm:mb-2 w-36 btn bg-gradient text-kyzzen-primary rounded-lg font-medium "
                  onClick={deleteSubCategory}
               >
                  Yes
               </Button>
            </div>
         </Modal>
      </div>
   )
}

export default SubCategory